export function clearPendingChatInput(contentWrapper) {
  try {
    contentWrapper.find(".g-chatform-text-input").val("").trigger("input");
  } catch (error) {
    if (!error || error.name !== "SecurityError") {
      throw error;
    }
  }
}
